<div class="box-content rd-widget widget-{{widgetConfig.widgetId}} widgetClient widgetNoTopBorder" *ngIf="(widgetData$ | async) as widgetData">
  <div class="fullWidth">
    <div class="table-part">
      <table class="widget-flex" style="height: 100%;" aria-hidden="true">
        <thead>
          <tr class="widget-ruller-flex">
            <th scope="col" class="widget-grid-column">&nbsp;</th>
            <th scope="col" class="widget-grid-column">&nbsp;</th>
            <th scope="col" class="widget-grid-column">&nbsp;</th>
            <th scope="col" class="widget-grid-column">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="background-color: #d8d4d4;" colspan="4"><widget-label [widget]="this" [fieldName]="'grossRent'" [align]="'left'" [bold]="true"></widget-label></td>
            <td style="background-color: #d8d4d4;" colspan="2"><widget-value [align]="'left'">{{currency}} {{(widgetData.grossRent || 0) | rdLocalizedNumber:0}}</widget-value></td>
            <td style="background-color: #d8d4d4;" colspan="4"><widget-label [widget]="this" [fieldName]="'grossMarketRent'" [align]="'left'" [bold]="true"></widget-label></td>
            <td style="background-color: #d8d4d4;" colspan="2"><widget-value [align]="'left'">{{currency}} {{(widgetData.grossMarketRent || 0) | rdLocalizedNumber:0}}</widget-value></td>
          </tr>
          <tr>
            <td style="background-color: #f0ecf4;" colspan="4"><widget-label [widget]="this" [fieldName]="'noiBeforeRentFree'" [align]="'left'" [bold]="true"></widget-label></td>
            <td style="background-color: #f0ecf4;" colspan="2"><widget-value [align]="'left'">{{currency}} {{(widgetData.noiBeforeRentFree || 0) | rdLocalizedNumber:0}}</widget-value></td>
            <td style="background-color: #f0ecf4;" colspan="4"><widget-label [widget]="this" [fieldName]="'netMarketRent'" [align]="'left'" [bold]="true"></widget-label></td>
            <td style="background-color: #f0ecf4;" colspan="2"><widget-value [align]="'left'">{{currency}} {{(widgetData.netMarketRent || 0) | rdLocalizedNumber:0}}</widget-value></td>
          </tr>
          <tr>
            <td style="background-color: #f8f4fc;" colspan="4"><widget-label [widget]="this" [fieldName]="'noiNetOfRentFree'" [align]="'left'" [bold]="true"></widget-label></td>
            <td colspan="2"><widget-value [align]="'left'">{{currency}} {{(widgetData.noiNetOfRentFree || 0) | rdLocalizedNumber:0}}</widget-value></td>
            <td colspan="4">&nbsp;</td>
            <td colspan="2">&nbsp;</td>
          </tr>
        </tbody>
      </table>  
    </div>
    <div class="space-part">&nbsp;</div>
  </div>
</div>
